import { render, staticRenderFns } from "./AdminGlobalSettings.vue?vue&type=template&id=077b784d"
import script from "./AdminGlobalSettings.vue?vue&type=script&lang=js"
export * from "./AdminGlobalSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports